import React from 'react';

const VerifyPhoneIcon = () => {
  return (
    <svg
      width="54"
      height="76"
      viewBox="0 0 54 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9999 58.1667H27.0366M13.0666 74.6667H40.9332C45.0403 74.6667 47.0938 74.6667 48.6625 73.8674C50.0424 73.1643 51.1642 72.0425 51.8673 70.6626C52.6666 69.094 52.6666 67.0404 52.6666 62.9334V13.0667C52.6666 8.95965 52.6666 6.90613 51.8673 5.33744C51.1642 3.95759 50.0424 2.83573 48.6625 2.13266C47.0938 1.33337 45.0403 1.33337 40.9332 1.33337H13.0666C8.95953 1.33337 6.90601 1.33337 5.33732 2.13266C3.95747 2.83573 2.83561 3.95759 2.13254 5.33744C1.33325 6.90613 1.33325 8.95966 1.33325 13.0667V62.9334C1.33325 67.0404 1.33325 69.094 2.13254 70.6626C2.83561 72.0425 3.95747 73.1643 5.33732 73.8674C6.90601 74.6667 8.95953 74.6667 13.0666 74.6667ZM28.8332 58.1667C28.8332 59.1792 28.0124 60 26.9999 60C25.9874 60 25.1666 59.1792 25.1666 58.1667C25.1666 57.1542 25.9874 56.3334 26.9999 56.3334C28.0124 56.3334 28.8332 57.1542 28.8332 58.1667Z"
        stroke="#06AED4"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VerifyPhoneIcon;
